import {http} from "@/api/http";
import {API_URL} from "@/api/base";


export async function getStores(company_id, page = 1, size = 20){
    return await http.get(
        `${API_URL}/v1/store/list?company=${company_id}&page=${page}&size=${size}`    )
}

export async function deleteStore(store_id){
    return await http.delete(
        `${API_URL}/v1/store/${store_id}/delete`    )
}
export async function importProducts(store_id){
    return await http.post(
        `${API_URL}/v1/store/${store_id}/task/import-products`,
        {}    )
}
export async function getOffers(store_id){
    return await http.post(
        `${API_URL}/v1/store/${store_id}/task/get-offers`,
        {}    )
}
export async function getOrders(store_id){
    return await http.post(
        `${API_URL}/v1/store/${store_id}/task/get-orders`,
        {}    )
}
export async function importStore(store_id){
    return await http.post(
        `${API_URL}/v1/store/${store_id}/task/import-products`,
        {}    )
}

export async function getStoreOzone(store_id){
    return await http.get(
        `${API_URL}/v1/store/ozon/${store_id}/info`    )
}

export async function newStoreOzon(data){
    return await http.post(
        `${API_URL}/v1/store/ozon/create`,
        data,
    )
}

export async function editStoreOzon(data){
    return await http.put(
        `${API_URL}/v1/store/ozon/${data.id}/update`,
        data,
    )
}


export async function getStoreWb(store_id){
    return await http.get(
        `${API_URL}/v1/store/wb/${store_id}/info`    )
}

export async function getWbWarehouses(){
    return await http.get(
        `${API_URL}/v1/store/wb/warehouses`    )
}

export async function newStoreWb(data){
    return await http.post(
        `${API_URL}/v1/store/wb/create`,
        data,
    )
}

export async function editStoreWb(data){
    return await http.put(
        `${API_URL}/v1/store/wb/${data.id}/update`,
        data,
    )
}


export async function getStoreYandex(store_id){
    return await http.get(
        `${API_URL}/v1/store/yandex/${store_id}/info`    )
}


export async function newStoreYandex(data){
    return await http.post(
        `${API_URL}/v1/store/yandex/create`,
        data,
    )
}

export async function editStoreYandex(data){
    return await http.put(
        `${API_URL}/v1/store/yandex/${data.id}/update`,
        data,
    )
}